/*
  TOG (Transova) Login Experience
  Shown when the app is accessed through the new TOG domain
  (advance.transova.com). Differences from the Vytelle experience:
    - Transova logo instead of the Vytelle logo
    - No "Always progressing" tagline and no link to the website
    - No sign up link
*/

import React, { useEffect } from "react";

// Redux
import { useDispatch, useSelector } from "react-redux";

// Antd
import { Col, Row } from "antd";

// Components
import Loading from "@Vytelle/authentication/src/components/Loading";
import LoginForm from "./LoginForm";

// Actions
import { logout } from "@Vytelle/authentication/src/store/actions/AuthAction";

// Localization
import LOCALIZATION from "@Vytelle/authentication/src/services/LocalizationService";

// Images
import transovaLogo from "@Vytelle/authentication/src/assets/images/transova-logo.jpg";

// Style
import "../style.scss";

function TransovaLogin() {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.Auth?.loading);

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  return (
    <>
      {loading && <Loading />}

      <Row className="authentication-wrapper transova">
        <Col xs={0} md={12} xl={16} className="image-col" />
        <Col xs={24} md={12} xl={8} className="form-col">
          <img className="login-logo" src={transovaLogo} alt="Transova logo" />
          <div className="shadow-card">
            <LoginForm showSignUp={false} />
          </div>
          <div className="footer-links">
            <span>{LOCALIZATION.NEED_HELP}?</span>
            <a href="mailto:info@vytelle.com">
              {LOCALIZATION.CONTACT_CUSTOMER_SUPPORT}
            </a>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default TransovaLogin;
